function switchTab(tabId) {
  const tabs = document.querySelectorAll('.mm-tab');
  tabs.forEach(tab => tab.classList.remove('mm-active'));

  const contents = document.querySelectorAll('[id$="-content"]');
  contents.forEach(content => content.style.display = 'none');

  const targetContent = document.getElementById(`mm-${tabId}-content`);
  if (targetContent) {
    targetContent.style.display = 'block';
  }

  const clickedTab = event.target;
  clickedTab.classList.add('mm-active');

  if (tabId === 'tab-1') {
    const items = document.querySelectorAll('.mm-feature-item');
    items.forEach((item, index) => {
      item.style.animation = 'none';
      setTimeout(() => {
        item.style.animation = `mm-fadeIn 0.6s ease forwards`;
        item.style.animationDelay = `${(index + 1) * 0.1}s`;
      }, 10);
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const featureItems = document.querySelectorAll('.mm-feature-item');

  featureItems.forEach(item => {
    item.addEventListener('click', function () {
      this.style.transform = 'translateX(10px) scale(1.02)';
      setTimeout(() => {
        this.style.transform = 'translateX(5px)';
      }, 150);
    });
  });
});